import UserModel from '@/models/entities/UserModel';

/**
 * L'utilisateur connecté : GET / PATCH /users/me.
 * GET au démarrage de l'application : source des informations de la session (cf. useAuthStore.loadCurrentUser).
 * Modifiables : firstName, lastName, et le mot de passe (plainPassword + currentPassword s'il en a déjà un).
 */
export default class CurrentUserModel extends UserModel {
  protected _path = '/users/me';
  protected _isSingleton = true;
}
